<template>
    <div class="m-radio-list" :class="inputClass">
        <label class="m-radio" v-for="(value, key) in radios" v-bind:key="key">
            <input type="radio" :value="key" :name="name">
            {{value}}
            <span></span>
        </label>
    </div>
</template>

<script>
export default {
  name: 'RadioComponent',
  props: ['id', 'value', 'name', 'placeholder', 'type', 'inputClass', 'radios']
}
</script>



// WEBPACK FOOTER //
// src/components/core/form/inputs/RadioComponent.vue